import { DirectorsParlorDetailContainer } from "@/containers/Parlor/DirectorsParlorContainer/DirectorsParlorDetailContainer";

function DirectorsParlorDetailPage() {
  return <DirectorsParlorDetailContainer id={39} />;
}

export default DirectorsParlorDetailPage;
